module.exports = __webpack_public_path__ + "static/front/img/dealer.2fd7df1d.svg";